import { HcmService } from "../../services/models/integrations/hcm";
import { formatRut } from "@/services/utils";
const moduleEpi = {
  namespaced: true,
  state: {
    epis: [],
    loading: false,
  },
  getters: {
    getEpis(state) {
      return state.epis;
    },
    getLoading(state) {
      return state.loading;
    },
  },
  mutations: {
    loadEpis(state, epis) {
      state.epis = epis;
    },
  },
  actions: {
    async loadEpis({ commit, state, rootGetters }) {
      state.loading = true;
      commit("loadEpis", []);
      const rut = rootGetters["patient/getPatientRut"];
      let rutWithoutFormat = formatRut(rut);
      let rutWithoutPoint = rutWithoutFormat.replaceAll(".", "");

      let epis = await HcmService.getPatientEpi(rutWithoutPoint.split("-")[0]);
      commit("loadEpis", epis);
      state.loading = false;
    },
  },
};

export default moduleEpi;
